module.exports = __webpack_public_path__ + "img/1434244995.e0de4492.jpg";